export default "__VITE_ASSET__BkEtDdxS__"